// This mostly duplicates styles from the reporting site, but they're simple (and this adds the heatmap) so it made sense to simply duplicate them
@import "../../../../shared/styles/base";

$heatmap-cold-hue: 33deg;
$heatmap-cold-saturation: 0%;
$heatmap-cold-lightness: 96.5%;

$heatmap-hot-hue: 41deg;
$heatmap-hot-saturation: 93.3%;
$heatmap-hot-lightness: 46.9%;

.Container {
  position: relative;
  max-width: 100%;
  overflow-x: auto;
}

.Table {
  line-height: 24px;
  width: 100%;

  th,
  td {
    height: fit-content;
    min-width: 10rem;
    width: 10rem;
    border: 1px solid #dadde2;
    padding: 1rem;

    a {
      color: inherit;
      text-decoration: none;
    }
  }

  th {
    background-color: #f3f4f6;
    position: sticky;

    &:first-child {
      left: 0;
      z-index: 1;
    }
  }

  tr:first-child th {
    top: 0;
    z-index: 1;

    &:first-child {
      z-index: 2;
    }
  }

  &.Heatmap {
    td {
      background-color: hsl(
        calc($heatmap-cold-hue + (($heatmap-hot-hue - $heatmap-cold-hue) * var(--analytics-table-heat-map-strength))),
        calc($heatmap-cold-saturation + (($heatmap-hot-saturation - $heatmap-cold-saturation) * var(--analytics-table-heat-map-strength))),
        calc($heatmap-cold-lightness + (($heatmap-hot-lightness - $heatmap-cold-lightness) * var(--analytics-table-heat-map-strength)))
      );
    }
  }
}
